import React, { createRef, JSX } from "react";
import { useScreenshot } from "../use-react-screenshot/src";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { BarGraphSimple } from "../components/BarGraphSimple";
import { SemiCircleGraphSimple } from "../components/SemiCircleGraphSimple";

interface PicturableProps {
    downloadName: string,
    createText: () => string,
    getMenu: () => JSX.Element,
    children?: JSX.Element,
    getChildren: (isDefault: boolean) => JSX.Element,
}

export const PicturableV2 = (props: PicturableProps) => {
    const { downloadName, createText, getMenu, children, getChildren } = props;
    const ref = createRef<HTMLDivElement>();
    const [image, takeScreenshot] = useScreenshot();
    const [isDefault, setIsDefault] = useStateWithCallbackLazy(true);
    
    const download = () => {
        if (image) {
            var element = document.createElement("a");
            element.href = image;
            element.download = downloadName;
            element.click();
            setIsDefault(x => true, () => {});
        }
      };
    const takeScreen = () => {
        const r = ref.current;
        setIsDefault(false, () => {
            setTimeout(() => {
                takeScreenshot(r);
                download();
            }, 10);
        });
        if (createText) {
            console.log(createText());
        }
    }
    
    return (<div>
        <span className={"floatRight pointer" + (isDefault ? "" : " collapsed")}>
            { getMenu && getMenu() }
            <img className="hoverable" width={24} src='/camera.png' alt='take a picture' onClick={() => takeScreen()} />
        </span>
        <div ref={ref}>
            {children}
            {getChildren(isDefault)}
        </div>
        <div className="collapsed">
            <img className="collapsed" src={image} alt='' onLoad={() => download()} />
        </div>
    </div>)
}

interface PicturableGraphProps {
    downloadName: string,
    createText?: () => string,
    title: string,
    children?: JSX.Element,
    labels: string[],
    data: number[],
    isBarGraph?: boolean,
    isSemiCircleGraph: boolean,
    groups: string[],
}

export const PicturableGraphV2 = (props: PicturableGraphProps) => {
    const { downloadName, createText, title, children, labels, data, isBarGraph, isSemiCircleGraph, groups } = props;
    const ref = createRef<HTMLDivElement>();
    const [image, takeScreenshot] = useScreenshot();
    const [isDefault, setIsDefault] = useStateWithCallbackLazy(true);
    
    const download = () => {
        if (image) {
            var element = document.createElement("a");
            element.href = image;
            element.download = downloadName;
            element.click();
            setIsDefault(x => true, () => {});
        }
      };
    const takeScreen = () => {
        const r = ref.current;
        setIsDefault(false, () => {
            setTimeout(() => {
                takeScreenshot(r);
                download();
            }, 10);
        });
        if (createText) {
            console.log(createText());
        }
    }
    
    return (<div>
        <span className={"floatRight pointer" + (isDefault ? "" : " collapsed")}>
            <a href={encodeURI("https://twitter.com/intent/tweet?text=https://statostuff.com\n\n" + createText?.())} target="twitter">
                <img className="hoverable" width={24} src='/twitterLogo2.png' alt='tweet' />
            </a>
            <img className="hoverable" width={24} src='/camera.png' alt='take a picture' onClick={() => takeScreen()} />
        </span>
        <div ref={ref}>
            <img className={"floatLeft " + (isDefault ? " collapsed" : "")} src="/Statostuff.png" alt="Statostuff" />
            {children}
            { isBarGraph && 
                <BarGraphSimple bgColor={isDefault ? '#333' : '#fff'} title={title} labels={labels} dataNow={data} groups={groups} />
            }
            { isSemiCircleGraph && 
                <SemiCircleGraphSimple bgColor={isDefault ? '#333' : '#fff'} title={title} labels={labels} dataNow={data} height={200} groups={groups} />
            }
        </div>
        <div className="collapsed">
            <img className="collapsed" src={image} alt='' onLoad={() => download()} />
        </div>
    </div>)
}